import { defaultTo } from 'ramda';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { getCompanyDescription } from './utils/helpers';
import { ETelemetryEvents } from '../../types/telemetry';
import { useApplicationContext } from '../../utils/applicationContext';
import { SuperAgentLevelViewContainer } from '../SuperAgentLevelViewContainer';
import { AboutCompany } from 'shared/components/AboutCompany/AboutCompany';
import { selectCompany, selectUser } from 'shared/slices';

export const AboutCompanyContainer = () => {
  const company = useSelector(selectCompany);
  const user = useSelector(selectUser);
  const { telemetry } = useApplicationContext();

  const {
    age,
    name,
    avatarUrl,
    companyName,
    description,
    experience,
    skills,
    moderationInfo,
    hasRgrParticipation,
    hasKokonParticipation,
  } = company;

  const descriptionList = React.useMemo(
    () =>
      getCompanyDescription({
        description: description ?? undefined,
        skills,
        companyName,
      }),
    [companyName, description, skills],
  );

  const experienceText = React.useMemo(() => `Опыт работы: ${experience || 'не указан'}`, [experience]);
  const ageText = React.useMemo(() => (age ? `${age} на\u00A0Циан` : ''), [age]);

  const showProfileLinkButton = React.useMemo(() => {
    if (user.isAuthenticated && 'realtyUserId' in user) {
      return user.realtyUserId === company.realtyUserId;
    }

    return false;
  }, [company, user]);

  React.useEffect(() => {
    telemetry.increment(ETelemetryEvents.CompanyPageStart);
  }, [telemetry]);

  return (
    <AboutCompany
      descriptionList={descriptionList}
      avatarUrl={avatarUrl}
      hasRgrParticipation={Boolean(hasRgrParticipation)}
      hasKokonParticipation={Boolean(hasKokonParticipation)}
      name={name}
      superAgent={<SuperAgentLevelViewContainer moderationInfo={defaultTo(null, moderationInfo)} />}
      experience={experienceText}
      age={ageText}
      showProfileLinkButton={showProfileLinkButton}
      isUserIdentifiedByDocuments={Boolean(moderationInfo?.isUserIdentifiedByDocuments)}
    />
  );
};
